export type WeChatOAuthIntent = 'auto'

export type WeChatAuthorizeResponse = {
  appId: string
  redirectUri: string
  state: string
}

declare global {
  interface Window {
    WxLogin?: new (options: {
      self_redirect?: boolean
      id: string
      appid: string
      scope: string
      redirect_uri: string
      state: string
      style?: string
      href?: string
    }) => void
  }
}

const WX_LOGIN_SCRIPT_SRC =
  'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'

let wxLoginScriptPromise: Promise<void> | null = null

export function loadWxLoginScript(): Promise<void> {
  if (window.WxLogin) {
    return Promise.resolve()
  }

  if (wxLoginScriptPromise) {
    return wxLoginScriptPromise
  }

  wxLoginScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[src="${WX_LOGIN_SCRIPT_SRC}"]`
    )
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        resolve()
      })
      existingScript.addEventListener('error', () => {
        reject(new Error('Failed to load WeChat login script'))
      })
      return
    }

    const script = document.createElement('script')
    script.src = WX_LOGIN_SCRIPT_SRC
    script.async = true
    script.onload = () => {
      resolve()
    }
    script.onerror = () => {
      reject(new Error('Failed to load WeChat login script'))
    }
    document.body.appendChild(script)
  })

  return wxLoginScriptPromise
}

export function renderWxLoginQr(input: {
  containerId: string
  appId: string
  redirectUri: string
  state: string
}) {
  if (!window.WxLogin) {
    throw new Error('WxLogin is not available after script load')
  }

  if (input.appId.trim().length === 0) {
    throw new Error('WeChat authorize response is missing appId')
  }

  if (input.redirectUri.trim().length === 0) {
    throw new Error('WeChat authorize response is missing redirectUri')
  }

  if (input.state.trim().length === 0) {
    throw new Error('WeChat authorize response is missing state')
  }

  new window.WxLogin({
    self_redirect: false,
    id: input.containerId,
    appid: input.appId,
    scope: 'snsapi_login',
    redirect_uri: encodeURIComponent(input.redirectUri),
    state: input.state,
    style: 'black',
    href: '',
  })
}
